// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"197":"dc89b817","709":"49d7d0f0","798":"fa8ed8aa","987":"43bec2cd"}[chunkId] + ".css";
};